import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';
import { physicalSettlementFactory } from '../utils/settlement';

type TUseUpdatePhysicalSettlementQueryParams = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useUpdatePhysicalSettlementQuery({
  onReject,
  onSuccess,
}: TUseUpdatePhysicalSettlementQueryParams) {
  const {
    isPending: isLoadingUpdatePhysicalSettlement,
    isError: isErrorUpdatePhysicalSettlement,
    execute: updatePhysicalSettlement,
    isSuccess: isSuccessUpdatePhysicalSettlement,
    ...query
  } = useMutation(
    ({ formModel }) =>
      API.updatePhysicalSettlement(physicalSettlementFactory(formModel)),
    { onReject, onSuccess }
  );

  return {
    updatePhysicalSettlement,
    isErrorUpdatePhysicalSettlement,
    isLoadingUpdatePhysicalSettlement,
    isSuccessUpdatePhysicalSettlement,
    query,
  };
}
